import api from "../utils/axios";
import { useMutation } from "@tanstack/react-query";

export const useUploadFiles = () => {
  // raw skips the image compressor — for source artwork that has to be stored
  // exactly as supplied.
  const uploadSingle = async ({ file, folder = "temp", raw = false }) => {
    const formData = new FormData();
    formData.append("files", file);
    formData.append("folder", folder);
    if (raw) formData.append("raw", "true");
    const res = await api.post("/admin/upload", formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    return res.data?.data || [];
  };

  return { uploadSingle };
};

export const useDeleteUpload = (options = {}) =>
  useMutation({
    mutationFn: async ({ key, keys }) => {
      const res = await api.delete("/admin/upload", { data: { key, keys } });
      return res.data;
    },
    ...options,
  });

export const getFileSignedUrl = async (url) => {
  const res = await api.get(
    `/admin/upload/signedUrl?url=${encodeURIComponent(url)}`
  );
  return res.data?.data;
};
